import React, {useEffect, useRef, useState} from 'react';
import {
  calculateSumOfEachRow,
  calculateTotalSum,
  deleteRowHandler,
  updateTableCellHandler
} from "../SellFactor/SellFactorFunctions";
import tableCalc from "../../utils/tableCalc";
import {ReactTabulator} from "react-tabulator";
import tabulatorTableOptions from "../../utils/TabulatorTableOptions";
import {formatToPersianAddComma, parseToEnRemoveComma} from "../../utils/CommaSeparator";
import NewTabulator from "../NewTabulator/NewTabulator";

const SaleReturnTable = ({sendData, setSendData, initialData, componentData, setComponentData,}) => {


  // const tableRef = useRef()
  const celEditHandler = cell => {
    setSendData({tableData: calculateSumOfEachRow(sendData.tableData)})
  }
  // useEffect(() => {
  //   // in this section i Register cellEdited  To prevent So many Problems in Return I Off The Registered And Register Again When component Mount
  //   if (tableRef.current !== null && tableRef.current !== undefined) {
  //     if (tableRef.current.table !== null && tableRef.current.table !== undefined) {
  //       tableRef.current?.table?.on("cellEdited", celEditHandler);
  //       const css = "font-size: 22px;color:red;"
  //       console.log("%c" + "celEditHandler Registered", css);
  //       return () => {
  //         const css = "text-shadow: 1px 1px 2px black, 0 0 2px blue, 0 0 0.2em blue; font-size: 14px;"
  //         console.log("%c" + "Component unmounted or updated", css);
  //         tableRef.current?.table?.off("cellEdited", celEditHandler);
  //       }
  //     }
  //   }
  //
  //
  // }, [sendData.tableData])

  const [reload, setReload] = useState(false)

  const [sum, setSum] = useState(0);
  useEffect(() => {
    const newSum = isNaN(calculateTotalSum(sendData)) ? 0 : calculateTotalSum(sendData)
    setSum(newSum)

  }, [sendData]);
  // MUST BE TWO seprate useEffect To Work
  useEffect(() => {
    setSendData({tableData: calculateSumOfEachRow(sendData.tableData)})
  }, [reload]);


  const tableColumns = [
    {
      title: "حذف", headerSort: false, formatter: "buttonCross", // width: 60,
      style: {display: 'flex', justifyContent: 'center', alignItems: 'center'},
      cellClick: function (e, cell) {
        console.log("حذف حذف حذف");
        const productId = cell.getData().productId;
        const storeId = cell.getData().storeId;
        const tableData = deleteRowHandler(sendData.tableData, productId, storeId);
        setSendData({tableData})
      }
    },
    {
      title: "کد کالا", field: 'productId', visible: true,
      style: {display: 'flex', justifyContent: 'center', alignItems: 'center'},
    },
    {
      title: "نام کالا", field: 'productName',
      style: {display: 'flex', justifyContent: 'center', alignItems: 'center'},
    },
    {
      title: "گروه کالا", field: 'productGroup',
      style: {display: 'flex', justifyContent: 'center', alignItems: 'center'},
    },
    {
      title: "رنگ", field: 'productColor',
      style: {display: 'flex', justifyContent: 'center', alignItems: 'center'},
    },
    {
      title: "سایز", field: 'productSize',
      style: {display: 'flex', justifyContent: 'center', alignItems: 'center'},
    },
    {
      title: " کد انبار", field: "storeId", visible: false,
      style: {display: 'flex', justifyContent: 'center', alignItems: 'center'},
    },
    {
      title: "انبار", field: "storeName", visible: true,
      style: {display: 'flex', justifyContent: 'center', alignItems: 'center'},
    },
    {
      title: "قیمت", field: 'price', sorter: "number", editor: "number", formatter: tableCalc.separateNumbers,

      style: {display: 'flex', justifyContent: 'center', alignItems: 'center'},

      cellEdited: function (e, cell) {
        const value = parseToEnRemoveComma(e.target.value)

        const productId = cell.getData().productId;
        const storeId = cell.getData().storeId;
        const tableData = updateTableCellHandler(sendData.tableData, productId, storeId, "price", value)
        setSendData({tableData});
        setReload(!reload);

      },
    },
    {
      title: "تعداد", field: 'number', editor: "number", formatter: tableCalc.separateNumbers,
      cellEdited: function (e, cell) {
        const value = parseToEnRemoveComma(e.target.value)
        const productId = cell.getData().productId;
        const storeId = cell.getData().storeId;
        const tableData = updateTableCellHandler(sendData.tableData, productId, storeId, "number", value)
        setSendData({tableData});
        setReload(!reload);

      },
      style: {display: 'flex', justifyContent: 'center', alignItems: 'center'},

      bottomCalc: tableCalc.sum,

    },
    {
      title: "جمع کل", field: "total", bottomCalc: tableCalc.sum,
      style: {display: 'flex', justifyContent: 'center', alignItems: 'center'},
    },

    {title: "  آدی موجودی", field: "inventoryId", visible: false,},
    {title: "آدی جزء", field: "particleFactorId", visible: false,},
    {field: "recordId", visible: false,},


  ];


  return (
    <div className="separate-factor__newSellComponent"
      // ref={seperateFac}
    >


      <NewTabulator
        columns={tableColumns}
        data={sendData.tableData}
        style={{height: "70vh"}}
        className={"header__color__F1F1F1"}

      />
      {/*<ReactTabulator*/}
      {/*  ref={tableRef}*/}
      {/*  columns={tableColumns}*/}
      {/*  // data={dataEdit.main !== undefined ? dataEdit.particle.data : [] }*/}
      {/*  data={sendData.tableData}*/}
      {/*  // dataChanged={(newData) => console.log("dataChanged", newData)}*/}
      {/*  options={tabulatorTableOptions.tableOptions}*/}
      {/*  style={{height: "70vh"}}*/}

      {/*/>*/}
      <div> جمع کل : {formatToPersianAddComma(sum)}</div>

    </div>
  );
};

export default SaleReturnTable;
